import { animate, style, transition, trigger } from "@angular/animations";

export const enterAndLeave = trigger('enterAndLeave', [
    transition(':enter', [
        style({ height: '0px' }),
        animate('.2s cubic-bezier(0, 0, 0.2, 1)', style({ height: "*" })),
    ]),
    transition(':leave', [
        animate('.2s linear', style({ height: '0px' })),
    ]),
])